<script lang="ts">
    import { createEventDispatcher, onMount } from "svelte";
    import { fade } from "svelte/transition";
    const dispatch = createEventDispatcher();

    let visible = false;
    onMount(() => {
        // Small delay to ensure transition plays
        setTimeout(() => (visible = true), 50);
    });
</script>

<button
    class="gift-btn"
    class:visible
    on:click={() => dispatch("click")}
    aria-label="New Unlock"
    out:fade={{ duration: 300 }}
>
    <div class="icon-container">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        >
            <polyline points="20 12 20 22 4 22 4 12"></polyline>
            <rect x="2" y="7" width="20" height="5"></rect>
            <line x1="12" y1="22" x2="12" y2="7"></line>
            <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path>
            <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>
        </svg>
    </div>
</button>

<style>
    .gift-btn {
        background: #ffeb3b;
        color: #333;
        border: none;
        border-radius: 50%;
        width: 48px;
        height: 48px;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
        z-index: 100;
        opacity: 0;
        transform: scale(0.8);
        transition:
            opacity 0.5s ease-out,
            transform 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        animation: glow 3s infinite ease-in-out;
    }

    .gift-btn.visible {
        opacity: 1;
        transform: scale(1);
    }

    .icon-container {
        width: 24px;
        height: 24px;
    }

    @keyframes glow {
        0%,
        100% {
            box-shadow: 0 0 5px rgba(255, 235, 59, 0.5);
        }
        50% {
            box-shadow: 0 0 20px rgba(255, 235, 59, 0.8);
        }
    }
</style>
